import { render, staticRenderFns } from "./AlignCenterVIcon.vue?vue&type=template&id=da03b426&"
import script from "./AlignCenterVIcon.vue?vue&type=script&lang=js&"
export * from "./AlignCenterVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports